<template>
  <div class="md-layout text-center md-alignment-center-center" style="min-height: 100vh;">
    <div class="md-layout-item md-size-33 md-medium-size-50 md-small-size-70 md-xsmall-size-100">
      <login-card header-color="green">
        <img slot="logo" src="img/logo-black.png" style="border-radius: unset">
        <h4 slot="title" class="title"></h4>
        <p slot="description" class="description">If you forgot your password enter your email and we’ll send you a link to reset it</p>
        <md-field class="md-form-group" :class="{'md-invalid':isInvalid}" slot="inputs">
          <md-icon>email</md-icon>
          <label>Email...</label>
          <md-input v-model="email" type="email" @keydown.native.enter="submit"></md-input>
          <span class="md-error">Something is wrong. Please check if the email address is correct</span>
        </md-field>
        <div slot="footer">
          <md-button slot="footer" class="md-simple md-success md-lg" v-on:click="submit">
            Continue
          </md-button>
          <md-button class="md-simple md-warning md-lg" v-on:click="backToLogin">
            Back to login
          </md-button>
        </div>
      </login-card>
    </div>
  </div>
</template>
<script>

import {LoginCard} from '@/components'
import AuthService from "@/services/AuthService";

export default {
  components: {
    LoginCard
  },
  data () {
    return {
      email: null,
      isInvalid: false
    }
  },
  methods: {
    submit() {
      AuthService.ResetPassword(this.email)
        .then(response => {
          this.$router.push('/passwordResetRequested');
        })
        .catch(error => {
          console.log(error);
          this.isInvalid = true;
        });
    },
    backToLogin() {
      this.$router.push('/login');
    }
  }
}
</script>

<style>
</style>
